module.exports = __webpack_public_path__ + "static/media/qrcode.2059afc4.png";